import React, { useState, useEffect } from "react";
import { Disclosure } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/20/solid";
import { filters } from "../../mock/DropdownOptions";
import { years } from "../../functions/YearGenerate";
import SearchIcon from "@mui/icons-material/Search";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { getAllCountries } from "../../service/MainService";

const ProjectFilter = ({ onFilterChange }) => {
  const [selectedFilters, setSelectedFilters] = useState({});

  const [selectedSize, setSelectedSize] = useState("");
  const [country, setCountry] = useState([]);


  useEffect(() => {  
    const fetchData = async () => {
      try {
        const CountryList = await getAllCountries();
        setCountry(CountryList);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const handleFilterChange = (sectionId, value) => {
    const newSelectedFilters = { ...selectedFilters, [sectionId]: value };
    const prevSelectedValue = selectedFilters[sectionId];
    if (prevSelectedValue && prevSelectedValue !== value) {
      onFilterChange({ ...newSelectedFilters, [sectionId]: value });
    } else {
      onFilterChange(newSelectedFilters);
    }
    setSelectedFilters(newSelectedFilters);
  };

  const handleSizeChange = (value) => {
    setSelectedSize(value);
    handleFilterChange("area", value); 
  };

  return (
    <div className="">
      <span className="text-md text-slate-500 font-normal flex items-center gap-4">
        <SearchIcon /> Search Projects
      </span>
      <div className="flex flex-col mt-3 lg:mt-5 p-2 gap-2">
        {filters.map(
          (section) =>
            section.id !== "modeling" &&
            section.id !== "rendering" && (
              <Disclosure
                as="div"
                key={section.id}
                className="border-b-2 border-gray-200 py-1"
              >
                {({ open }) => (
                  <>
                    <h3 className="-my-2 lg:my-0 lg:flow-root">
                      <Disclosure.Button className="flex w-full items-center justify-between bg-white py-2 lg:py-3 text-sm text-gray-400 hover:text-gray-500">
                        <span className="font-semibold text-gray-900">
                          {section.name}
                        </span>
                        <span className="ml-4 flex items-center">
                          {open ? (
                            <MinusIcon className="h-5 w-5" aria-hidden="true" />
                          ) : (
                            <PlusIcon className="h-5 w-5" aria-hidden="true" />
                          )}
                        </span>
                      </Disclosure.Button>
                    </h3>
                    <Disclosure.Panel className="pt-3 lg:pt-6">
                      <div className="space-y-3">
                        {section.id === "area" ? (
                          <select
                            value={selectedSize}
                            onChange={(e) => handleSizeChange(e.target.value)}
                            className="w-full border border-gray-500 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
                          >
                            <option className="font-normal" value="">
                              Select Area
                            </option>
                            {section.options.map((sizeOption) => (
                              <option
                                key={sizeOption.value}
                                value={sizeOption.value}
                              >
                                {sizeOption.label}
                              </option>
                            ))}
                          </select>
                        ) : section.id === "location" ? (
                          <select
                            value={selectedFilters[section.id]}
                            onChange={(e) =>
                              handleFilterChange(section.id, e.target.value)
                            }
                            className="w-full border border-gray-500 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
                          >
                            <option className="font-normal" value="">
                              Select Country
                            </option>
                            {country.map((countryOption) => (
                              <option
                                key={countryOption.id}
                                value={countryOption.CountryName}
                              >
                                {countryOption.CountryName}
                              </option>
                            ))}
                          </select>
                        ) : section.id === "year" ? (
                          <select
                            value={selectedFilters[section.id]}
                            onChange={(e) =>
                              handleFilterChange(section.id, e.target.value)
                            }
                            className="w-full border border-gray-500 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
                          >
                            <option className="font-normal" value="">
                              Select Year
                            </option>
                            {years.map((year) => (
                              <option key={year} value={year.value}>
                                {year.label}
                              </option>
                            ))}
                          </select>
                        ) : section.id === "name" ? (
                          <div className="relative">
                            <input
                              type="text"
                              value={selectedFilters[section.id]}
                              onChange={(e) =>
                                handleFilterChange(section.id, e.target.value)
                              }
                              placeholder="Search by name"
                              className="w-full border border-gray-500 rounded-md py-2 px-3 pr-10 shadow-sm focus:outline-none focus:border-blue-500"
                            />

                            <PersonSearchIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                          </div>
                        ) : section.id === "typologySubCategory" ? (
                          <div>
                            {section.options.map((option) => (
                              <div key={option.value}>
                                <p className="font-semibold text-sm text-gray-700 mt-2">
                                  {option.label}
                                </p>
                                <div className="ml-4 space-y-1">
                                  {option.subcategories.map((subcategory) => (
                                    <div key={subcategory.value}>
                                      <input
                                        type="checkbox"
                                        id={subcategory.value}
                                        value={subcategory.value}
                                        checked={
                                          selectedFilters[section.id] ===
                                          subcategory.value
                                        }
                                        onChange={(e) =>
                                          handleFilterChange(
                                            section.id,
                                            e.target.checked
                                              ? subcategory.value
                                              : null
                                          )
                                        }
                                        className="form-checkbox h-5 w-5  text-indigo-600 transition duration-150 ease-in-out"
                                      />
                                      <label
                                        htmlFor={subcategory.value}
                                        className="ml-2 text-sm lg:text-md font-normal text-gray-600"
                                      >
                                        {subcategory.label}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          section.options.map((option, optionIdx) => (
                            <div
                              key={option.value}
                              className="flex items-center"
                            >
                              <div>
                                <input
                                  id={`filter-${section.id}-${optionIdx}`}
                                  type="checkbox"
                                  className="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out"
                                  onChange={(e) =>
                                    handleFilterChange(
                                      section.id,
                                      e.target.checked ? option.value : null
                                    )
                                  }
                                  checked={
                                    selectedFilters[section.id] === option.value
                                  }
                                />
                                <label
                                  htmlFor={`filter-${section.id}-${optionIdx}`}
                                  className="ml-3 text-sm lg:text-md font-normal text-gray-600"
                                >
                                  {option.label}
                                </label>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            )
        )}
      </div>
    </div>
  );
};

export default ProjectFilter;
